module.exports = __webpack_public_path__ + "media/icons/calendar-icon-c12972dc.png";